import React from "react";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import { CUMPLE, NO_CUMPLE } from "../utils/documentos_utils";

export default function IndicadorCumplimiento({ estado, detalle }) {
  if (estado === NO_CUMPLE) {
    return (
      <Tooltip title={detalle} arrow>
        <Chip
          size="small"
          color="error"
          variant="outlined"
          icon={<WarningAmberRoundedIcon />}
          label={NO_CUMPLE}
          sx={{ fontWeight: 600, backgroundColor: "#FFF1F1" }}
        />
      </Tooltip>
    );
  }

  if (estado === CUMPLE) {
    return (
      <Chip
        size="small"
        color="success"
        variant="outlined"
        icon={<CheckCircleOutlineRoundedIcon />}
        label={CUMPLE}
      />
    );
  }

  return (
    <Tooltip title="El documento no tiene valores pactados o medidos para comparar" arrow>
      <Chip size="small" variant="outlined" icon={<HelpOutlineRoundedIcon />} label={estado} />
    </Tooltip>
  );
}
